import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminSettingShoppingCart';

const GetSettingShoppingCartReducer = handleActions({
    [Actions.getSettingShoppingCartRequested]: (state) => ({
        ...state,
        isFetching: true,
        isCompleted: false,
    }),
    [Actions.getSettingShoppingCartReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        data: action.payload,
    }),
    [Actions.getSettingShoppingCartReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        errors: action.payload.errors,
    }),
    [Actions.getSettingShoppingCartClear]: () => ({
        isCompleted: false,
        isSuccessful: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    isCompleted: false,
    data: {},
    errors: {},
});

const UpdateSettingShoppingCartReducer = handleActions({
    [Actions.updateSettingShoppingCartRequested]: (state) => ({
        ...state,
        isFetching: true,
        isCompleted: false,
        isSuccessful: undefined,
    }),
    [Actions.updateSettingShoppingCartReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        isSuccessful: true,
        data: action.payload,
    }),
    [Actions.updateSettingShoppingCartReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        isSuccessful: false,
        errors: action.payload.errors,
    }),
    [Actions.updateSettingShoppingCartClear]: () => ({
        isFetching: false,
        isCompleted: false,
        isSuccessful: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    isCompleted: false,
    isSuccessful: undefined,
    data: {},
    errors: {},
});

export default combineReducers({
    get: GetSettingShoppingCartReducer,
    update: UpdateSettingShoppingCartReducer,
});
